import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './Slices/authSlice'
import configReducer from './Slices/configSlice'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['authData'],
};
const rootReducer = combineReducers({
    authData: authReducer,
    config: configReducer
});
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});
export const persistor = persistStore(store);